import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks, singleEmailValidation } from "@/services/misc/functions/ValidationFunctions";

export default class CreateStagingForm {
  public selectedEnvironment: string = '';

  public wpEmail: string = '';

  public wpUsername: string = '';

  public wpPassword: string = '';

  public rules: { [name: string]: FormValidationFunction[] } = {
    username: [
      (v: string) => !!v || 'WP User is required',
      (v: string) => v.length <= 24 || 'WP User can be at most 24 characters',
      (v: string) => v.length >= 3 || 'WP User has to be at least 3 characters',
      (v: string) => !v || /^[a-zA-Z0-9]+$/.test(v) || 'WP User must contain only letters and numbers',
    ],
    password: [
      (v: string) => !!v || 'Password is required',
      ...PasswordValidationCallbacks,
    ],
    email: [
      ...singleEmailValidation(),
    ],
  };
}
